import StopLabel from "./StopLabel";
import { sortBy } from "lodash";
import { utcToZonedTime } from "date-fns-tz";
import appConstants from "../../../../../../appConstants";
import format from "date-fns/format";

const getStopsList = (stops) => {
  return sortBy(
    stops.map((stop) => ({
      label: <StopLabel stop={stop} />,
      value: stop.stopId,
      isStopCompleted: stop.isStopCompleted,
      stopSequence : stop.stopSequence
    })),
    "stopSequence"
  );
};

const getProImagesCount = (proId,proData) => {
  const { proImages = {} } = proData?.find((pro) => pro.proId === proId) ?? {};
  return Object.keys(proImages).reduce((acc,key)=>{
    return acc + proImages[key]?.length
  },0)
}

const base64toBlob = (data, sliceSize = 512) => {
  const byteCharacters = atob(data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: 'application/pdf' });
};

const getImageLocationList = (images, isEDR = false) => {
  const imageURLDetailsList = [];
  images.forEach((url) => {
    const {file, timestamp, latitude, longitude } = isEDR
      ? extractEDRImageTimeStampValuesFromURL(url)
      : extractTimeStampLatLongValuesFromURL(url);
    imageURLDetailsList.push({ timestamp, latitude, longitude, file });
  });
  return imageURLDetailsList;
};

const getImageDetailsFromImageURLs = (imageData) => {
  let imageURLDetailsList = [];
  const stopImagesData = imageData.stopImages;

  // Process stop images
  for (const stopKey in stopImagesData) {
    const stopImages = stopImagesData[stopKey];
    imageURLDetailsList = [
      ...imageURLDetailsList,
      ...getImageLocationList(stopImages),
    ];
  }

  // Process pro EDR
  const proImagesData = imageData.pros;
  proImagesData.forEach((proImageData) => {
    const eDRType = proImageData.eDR;
    for (const edrKey in eDRType) {
      const eDRImages = eDRType[edrKey];
      imageURLDetailsList = [...imageURLDetailsList, ...getImageLocationList([eDRImages], true)];
    }
  });

   // Process pro images
  proImagesData.forEach((proImageData) => {
    const proImagesByType = proImageData.proImages;
    for (const proKey in proImagesByType) {
      const proImages = proImagesByType[proKey];
      imageURLDetailsList = [
        ...imageURLDetailsList,
        ...getImageLocationList(proImages),
      ];
    }
  });
  return imageURLDetailsList;
};

const getAddressFromReverseGeocodingResults = ({
    latitude,
    longitude,
    reverseGeoCodedLocations,
  }) => {
  if (latitude && longitude && reverseGeoCodedLocations?.length) {
    const address =
      reverseGeoCodedLocations.find(
        (obj) =>
          Number(obj.Coords.Lat)?.toFixed(5) ===
            Number(latitude)?.toFixed(5) &&
          Number(obj.Coords.Lon)?.toFixed(5) === Number(longitude)?.toFixed(5)
      ) ?? {};
    return address;
  } else {
    return null;
  }
};

const extractTimeStampLatLongValuesFromURL = (url) => {
  const file = url.substring(url.lastIndexOf("/") + 1, url.indexOf("?")); //file details will be between last index and 1st ? mark
  const [, timestamp, latitude = undefined, longitude = undefined] =
    file.split("_");
  return { timestamp, latitude, longitude };
};

const extractEDRImageTimeStampValuesFromURL = (url) => {
  const file = url.substring(url.lastIndexOf("/") + 1, url.indexOf("?")); //file details will be between last index and 1st ? mark
  const [, , timestamp, latitude = undefined, longitude = undefined] = file.split("_");
  return { file, timestamp, latitude, longitude };
};

const getTerminalTimeFromTimestamp = (timestamp, terminalOffset) => {
  const dateTime = utcToZonedTime(new Date(timestamp), terminalOffset);
  const date = format(dateTime, appConstants.DATETYPES.MONTHDATEYEAR.format);
  const time = format(dateTime, appConstants.DATETYPES.TIME.format);
  return { date, time };
};

export {
  getStopsList,
  getProImagesCount,
  base64toBlob,
  getImageDetailsFromImageURLs,
  extractTimeStampLatLongValuesFromURL,
  getTerminalTimeFromTimestamp,
  getAddressFromReverseGeocodingResults,
  extractEDRImageTimeStampValuesFromURL
};
